import { Box, Button } from '@mui/material';

export default function FileUpload(props) {
  const {
    name,
    icon,
    title,
    style,
    accept,
    onChange,
    register,
    isDisabled,
    fileInputRef,
  } = props;
  return (
    <div>
      <Box>
        <Button
          variant="outlined"
          style={{
            width: '274px',
            textTransform: 'capitalize',
            fontSize: 16,
            fontWeight: '600',
            color: 'rgba(20, 97, 164, 1)',
            padding: '2px 15px',
            borderRadius: 8,
            ...style,
          }}
          startIcon={icon}
          component="label"
          disabled={isDisabled}>
          {title}
          <input
            hidden
            name="file"
            type="file"
            accept={accept}
            {...register(name, {
              required: true,
            })}
            ref={fileInputRef}
            onChange={onChange}
            value=""
            onClick={e => (e.target.value = null)}
          />
        </Button>
      </Box>
    </div>
  );
}
